import React from "react";

export const Spinner = ({ color = '#170C52', size = 12, style }) => {
    const baseStyle = {
        display: 'inline-block',
        width: size,
        height: size,
        border: `2px solid ${color}30`,
        borderTopColor: color,
        borderRadius: '50%',
        animation: 'spin 0.7s linear infinite',
        verticalAlign: 'middle',
        flexShrink: 0,
        ...style,
    };

    return <span style={baseStyle} />;
}

export default Spinner;
